<template>
	<app-page>
		<app-heading title="System Status" />
		<app-section>
			<h2>Global status</h2>
			<app-row class="mt-4">
				<app-cell>
					<h3>API</h3>
					<div :class="getColor(statuses.api.status)">{{statuses.api.message}}</div>
				</app-cell>
				<app-cell>
					<h3>MongoDB</h3>
					<div :class="getColor(statuses.mongo.status)">{{statuses.mongo.message}}</div>
				</app-cell>
				<app-cell>
					<h3>Redis</h3>
					<div :class="getColor(statuses.redis.status)">{{statuses.redis.message}}</div>
				</app-cell>
			</app-row>
		</app-section>
		<app-section class="mt-4">
			<h2>
				<span>Events status&nbsp;&nbsp;</span>
				<span
					:class="`${getColor(statuses.events.status)} subtitle-1`"
				>{{statuses.events.message}}</span>
			</h2>
			<app-row class="mt-4">
				<app-cell>
					<h3>Backlog</h3>
					<div :class="getColor()">{{statuses.events.backlog}}</div>
				</app-cell>
				<app-cell>
					<h3>Working</h3>
					<div :class="getColor()">
						<router-link
							:to="{ name: 'events-working' }"
							style="color: inherit;"
						>{{statuses.events.working}}</router-link>
					</div>
				</app-cell>
				<app-cell>
					<h3>Failed</h3>
					<div
						:class="getColor(statuses.events.failed > 0 ? 'error' : '')"
					>
						<router-link
							:to="{ name: 'events' }"
							style="color: inherit;"
						>{{statuses.events.failed}}</router-link>
					</div>
				</app-cell>
			</app-row>
		</app-section>
		<app-section class="mt-4">
			<h2>
				<span>Jobs status&nbsp;&nbsp;</span>
				<span
					:class="`${getColor(statuses.jobs.status)} subtitle-1`"
				>{{statuses.jobs.message}}</span>
			</h2>
			<app-row class="mt-4">
				<app-cell>
					<h3>Backlog</h3>
					<div :class="getColor()">{{statuses.jobs.backlog}}</div>
				</app-cell>
				<app-cell>
					<h3>Working</h3>
					<div :class="getColor()">
						<router-link
							:to="{ name: 'jobs-working' }"
							style="color: inherit;"
						>
							{{statuses.jobs.working}}
						</router-link>
					</div>
				</app-cell>
				<app-cell>
					<h3>Failed</h3>
					<div
						:class="getColor(statuses.jobs.failed > 0 ? 'error' : '')"
					>
						<router-link
							:to="{ name: 'jobs' }"
							style="color: inherit;"
						>{{statuses.jobs.failed}}</router-link>
					</div>
				</app-cell>
			</app-row>
		</app-section>
		<app-section class="mt-4">
			<h2>
				<span>App status&nbsp;&nbsp;</span>
				<span
					:class="`${getColor(statuses.app.status === 'error' && !statuses.app.errors.new
						? 'warning' : statuses.app.status)} subtitle-1`"
				>{{statuses.app.message}}</span>
			</h2>
			<app-row class="mt-4">
				<app-cell>
					<h3>Critical issues</h3>
					<div
						v-if="statuses.app.errors"
						:class="getColor(statuses.app.errors.total ? (statuses.app.errors.new ? 'error' : 'warning') : '')"
					>
						{{statuses.app.errors.total}} ({{statuses.app.errors.new}}|{{statuses.app.errors.ack}})
					</div>
				</app-cell>
				<app-cell>
					<h3>Other issues</h3>
					<div
						v-if="statuses.app.others"
						:class="getColor(statuses.app.others.total > 0 ? 'warning' : '')"
					>
						{{statuses.app.others.total}} ({{statuses.app.others.new}}|{{statuses.app.others.ack}})
					</div>
				</app-cell>
			</app-row>
		</app-section>
	</app-page>
</template>

<script>

/**
 * Status local type
 */
function Status() {
	this.status = 'warning'
	this.message = 'Not initialized'
}

export default {
	async created() {
		await Promise.all([
			this.getStatus('api', 'ping'),
			this.getStatus('mongo', 'mongodb'),
			this.getStatus('redis', 'redis'),
			this.getStatus('events', 'events'),
			this.getStatus('jobs', 'jobs'),
			this.getStatus('app', 'app'),
		])
	},
	data() {
		return {
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: false,
			}, {
				text: 'Status',
				value: 'status',
				sortable: false,
			}],
			statuses: {
				api: new Status(),
				mongo: new Status(),
				redis: new Status(),
				events: new Status(),
				jobs: new Status(),
				app: new Status(),
			},
		}
	},
	methods: {
		async getStatus(status, endpoint) {
			try {
				const systemStatus = await this.$ravello.request()
					.to('status')
					.to(endpoint)
					.get()
				this.statuses[status] = {
					...systemStatus,
					status: 'success',
				}
			} catch (err) {
				if (err.data) {
					const { message, details = {} } = err.data
					this.statuses[status] = {
						...details,
						message,
					}
				} else {
					this.statuses[status].message = err.message
				}
				this.statuses[status].status = 'error'
			}
		},
		getColor(status) {
			switch (status) {
			case 'warning':
				return 'orange--text text--darken-2'
			case 'error':
				return 'red--text text--darken-3'
			case 'success':
				return 'green--text text--darken-3'
			default:
				return 'blue--text text--darken-3'
			}
		},
	},
}
</script>
